import { Link } from "react-router-dom";
import { Mail, Sparkles } from "lucide-react";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function ComingSoon() {
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-20 text-center" data-testid="coming-soon-page">
      <div className="font-jp text-7xl text-white/10 select-none">浪人</div>
      <div className="font-mono text-[10px] tracking-[0.4em] text-[#FF3333] mt-4">WAIFU COLLECTION · STATUS</div>
      <h1 className="font-heading uppercase text-6xl md:text-8xl leading-[0.9] mt-3">
        Coming <br /><span className="text-stroke-red grunge-text">Soon.</span>
      </h1>
      <p className="font-sub text-white/60 mt-6 max-w-xl mx-auto leading-relaxed">
        The Forged Athletics streetwear drops are in the forge. Anime-inspired tees, rashguards, and limited drops — built for athletes who train in shadows.
      </p>

      <div className="mt-10 flex justify-center gap-3 flex-wrap">
        <Link to="/pricing" className="btn-forged-red" data-testid="coming-soon-pricing-link">
          <Sparkles className="w-4 h-4" /> Get the AI Program
        </Link>
        <Link to="/" className="btn-forged-ghost" data-testid="coming-soon-home-link">← Back home</Link>
      </div>

      <div className="mt-16 max-w-md mx-auto">
        <div className="flex items-center gap-2 justify-center mb-4">
          <Mail className="w-4 h-4 text-[#00E5FF]" />
          <div className="font-mono text-[10px] tracking-[0.4em] text-[#00E5FF]">FIRST DIBS</div>
        </div>
        <p className="font-sub text-white/50 text-sm mb-4">
          Drop your email — you'll be the first to know when the Waifu Collection launches.
        </p>
        <NewsletterSignup />
      </div>
    </div>
  );
}
